// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

// selectors
import { getFooterHTML, getFaq, getTopBestsellers } from 'shared/store/listingV2/selectors';
import { getSeoFooterContent } from 'shared/store/dynamicPage/selector';

// components
import ListingFaq from 'shared/components/Footer/components/ListingFaq';
import BestsellersPriceList from 'shared/components/Footer/components/BestsellersPriceList';

// styles
import { FooterWrapper, FooterGrid, CategorySection, SideSection } from './styles';

// helpers
import { useDynamicPage } from 'shared/routes/DynamicPage/helper';
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';
import sanitizeHTML from 'shared/helpers/utils/sanitizeHTML';
import { shouldShowListingFaq } from 'shared/components/Footer/components/ListingFaq/helpers';

function FooterV2() {
  const { isDynamicPageURL } = useDynamicPage();

  const footerHTML = useSelector(getFooterHTML);
  const faq = useSelector(getFaq);
  const footerSEOContent = useSelector(getSeoFooterContent);
  const footerHTMLContent = isDynamicPageURL ? footerSEOContent : footerHTML;
  const footerSection = useRemoteConfig('footerSection');
  const showListingFooter = get(footerSection, 'showListingFooter', true);
  const showBestsellers = get(footerSection, 'showBestsellers', false);
  const bestsellers = useSelector(getTopBestsellers);

  const isAeoFaqEnabled = Boolean(useRemoteConfig('isAeoFaqEnabled'));
  const showFaq = shouldShowListingFaq({
    faq,
    showListingFooter,
    isDynamicPageURL,
    isAeoFaqEnabled,
  });

  const hasSeoContent = !isEmpty(footerHTMLContent);
  const hasBestsellers = showBestsellers && !isEmpty(bestsellers);

  if (!showListingFooter || (!hasSeoContent && !hasBestsellers && !showFaq)) {
    return null;
  }

  return (
    <FooterWrapper data-at="listing-footer" data-test="listing-footer-v2">
      {(hasSeoContent || hasBestsellers) && (
        <FooterGrid>
          {hasSeoContent && (
            <CategorySection
              data-test="listing-footer-seo"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(footerHTMLContent) }}
            />
          )}
          {hasBestsellers && (
            <SideSection data-test="listing-footer-bestsellers">
              <BestsellersPriceList items={bestsellers} />
            </SideSection>
          )}
        </FooterGrid>
      )}
      {showFaq && <ListingFaq items={faq} />}
    </FooterWrapper>
  );
}

export default memo(FooterV2);
